import Vue from 'vue'

import XEUtils from 'xe-utils'
Vue.prototype.$XEUtils = XEUtils

import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'


// 创建一个空内容渲染
VXETable.renderer.add('NotData', {
	// 空内容模板
	renderEmpty(h, renderOpts) {
		return [ 
			<span >	Empty</span>
		]
	}
})

//自定义全局的格式化处理函数
//通过	formatter="formatDate" 或	:formatter="['formatDate', 'yyyy-MM-dd']"  使用

VXETable.formats.mixin({
	// 格式化真假
	formatTF({
		cellValue
	}) {
		return cellValue === true ? '是' : ''
	},
	// 格式化下拉选项
	formatSelect({
		cellValue
	}, list) {
		const item = list.find(item => item.value === cellValue)
		return item ? item.label : ''
	},
	// 格式化日期，默认 yyyy-MM-dd HH:mm:ss
	formatDate({
		cellValue
	}, format) {
		return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
	},
	// 格式金额，默认2位数
	formatAmount({
		cellValue
	}, digits) {
		return XEUtils.commafy(cellValue, {
			digits: digits || 2
		})
	},
	// 格式化银行卡，默认每4位隔开
	formatBankcard({
		cellValue
	}) {
		return XEUtils.commafy(cellValue, {
			spaceNumber: 4,
			separator: ' '
		})
	},
	// 四舍五入,默认两位数
	// formatter="formatFixedNumber"
	// :formatter="['formatFixedNumber', '1']" 
	formatFixedNumber({
		cellValue
	}, digits) {
		return XEUtils.toNumber(cellValue).toFixed(digits || 2)
	},
	// 截取小数,默认两位数
	formatCutNumber({
		cellValue
	}, digits) {
		return XEUtils.toFixedString(cellValue, digits || 2)
	},
	// 转换 moment 类型为字符串
	toMomentString({
		cellValue
	}, format) {
		return cellValue ? cellValue.format(format) : ''
	}
})

//全局化设置表格参数
VXETable.setup({
	// size: 'mini', // 全局尺寸
	// zIndex: 100, // 全局 zIndex 起始值，如果项目的的 z-index 样式值过大时就需要跟随设置更大，避免被遮挡
	// version: 0, // 版本号，对于某些带数据缓存的功能有用到，上升版本号可以用于重置数据
	table: {
		// 	showHeader: true,
		// 	keepSource: false,
		// 	animat: true,
		// 	cloak: false,
		// 	delayHover: 250,
		showOverflow: true,
		showHeaderOverflow: true,
		showFooterOverflow: true,
		// 	size: null,
		resizable: true,
		autoResize: true,
		stripe: true,
		border: true,
		round: true,
		// 	radioConfig: {
		// 		trigger: 'default'
		// },
		// 	checkboxConfig: {
		// 		trigger: 'default'
		// 	},
		// 	sortConfig: {
		// 		remote: false,
		// 		trigger: 'default',
		// 		orders: ['asc', 'desc', null],
		// 		sortMethod: null
		// 	},
		// 	filterConfig: {
		// 		remote: false,
		// 		filterMethod: null
		// 	},
		// 	expandConfig: {
		// 		trigger: 'default'
		// 	},
		// 	treeConfig: {
		// 		children: 'children',
		// 		hasChild: 'hasChild',
		// 		indent: 20
		// 	},
		// 	tooltipConfig: {
		// 		theme: 'dark',
		// 		enterable: false
		// 	},
		// 	editConfig: {
		// 		mode: 'cell'
		// 	},
		// 	contextMenu: {
		// 		visibleMethod() {}
		// 	},
		rowId: 'ID', // 行数据的唯一主键字段名
		// 	importConfig: {
		// 		modes: ['insert', 'covering']
		// 	},
		// 	exportConfig: {
		// 		isPrint: true,
		// 		modes: ['current', 'selected']
		// 	},
		// 	customConfig: {
		// 		storage: false
		// 	},
		// 	scrollX: {
		// 		gt: 60
		// 	},
		// 	scrollY: {
		// 		gt: 100
		// 	}
	},
	// grid: {
	// 	size: null,
	// 	zoomConfig: {
	// 		escRestore: true
	// 	},
	// 	pagerConfig: {
	// 		perfect: false
	// 	},
	// 	toolbar: {
	// 		perfect: false
	// 	},
	// 	proxyConfig: {
	// 		autoLoad: true,
	// 		message: true,
	// 		props: {
	// 			list: null, // 用于列表，读取响应数据
	// 			result: 'result', // 用于分页，读取响应数据
	// 			total: 'page.total' // 用于分页，读取总条数
	// 		}
	// 		beforeItem: null,
	// 		beforeColumn: null,
	// 		beforeQuery: null,
	// 		afterQuery: null,
	// 		beforeDelete: null,
	// 		afterDelete: null,
	// 		beforeSave: null,
	// 		afterSave: null
	// 	}
	// },
	pager: {
		size: 'mini',
		autoHidden: true,
		perfect: false,
		pageSize: 10,
		pagerCount: 7,
		pageSizes: [10, 50, 100, 500, 2000],
		layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
	},
	// form: {
	// 	preventSubmit: false
	// 	validConfig: {
	// 		autoPos: true
	// 	},
	// 	size: null,
	// 	colon: false
	// },
	// input: {
	// 	size: null,
	// 	transfer: false
	// 	parseFormat: 'yyyy-MM-dd HH:mm:ss.SSS',
	// 	labelFormat: '',
	// 	valueFormat: '',
	// 	startWeek: 1,
	// 	digits: 2
	// },
	// textarea: {
	// 	size: null
	// 	autosize: {
	// 		minRows: 1,
	// 		maxRows: 10
	// 	}
	// },
	// select: {
	// 	size: null,
	// 	transfer: false
	// },
	// toolbar: {
	// 	size: null,
	// 	import: {
	// 		mode: 'covering'
	// 	},
	// 	export: {
	// 		types: ['csv', 'html', 'xml', 'txt']
	// 	},
	// 	custom: {
	// 		isFooter: true
	// 	},
	// 	buttons: []
	// },
	// button: {
	// 	size: null,
	// 	transfer: false
	// },
	// radio: {
	// 	size: null
	// },
	// checkbox: {
	// 	size: null
	// },
	// switch: {
	// 	size: null
	// },
	// modal: {
	// 	// size: null,
	// 	minWidth: 340,
	// 	minHeight: 200,
	// 	lockView: true,
	// 	mask: true,
	// 	duration: 3000,
	// 	marginSize: 0,
	// 	dblclickZoom: true,
	// 	showTitleOverflow: true
	// 	storage: false
	// },
	// list: {
	// 	scrollY: {
	// 		gt: 100
	// 	}
	// }
})

Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
